import script from "./ConfirmOrganization.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmOrganization.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmOrganization.vue?vue&type=style&index=0&id=800c50d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-800c50d6"]])

export default __exports__